/* eslint-disable */

import React from "react";

import { useState } from "react";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import { useNavigate } from "react-router-dom";
import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import OrganisationActivityElement from "../../../ui-components/organisation-activity-element/organisation-activity-element.tsx";
import {
  EXAMPLE_ACCOUNT_USER_URL,
  EXAMPLE_ORGANISATION_ALPHA_NAME,
  EXAMPLE_ORGANISATION_ALPHA_URL,
  EXAMPLE_ORGANISATION_BETA_NAME,
  EXAMPLE_ORGANISATION_BETA_URL,
} from "../../../services/constants";

import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import WaterfallIcon from "../../../ui-components/waterfall-icon/waterfall-icon.tsx";
import { Color, SausageStyleColor, Size } from "../../../logic/enums.ts";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextHeading2 from "../../../ui-components/raindrop-text-heading-2/raindrop-text-heading-2.tsx";
import { fetchGraphQL } from "../../../services/api-raindrop.js";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";
import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";
import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import RaindropTextFootnote from "../../../ui-components/raindrop-text-footnote/raindrop-text-footnote.tsx";
import RaindropSparkleCurtain from "../../../ui-components/raindrop-sparkle-curtain/raindrop-sparkle-curtain.tsx";
import RaindropTextCallout from "../../../ui-components/raindrop-text-callout/raindrop-text-callout.tsx";
import OrganisationListElement from "../../../ui-components/organisation-list-element/organisation-list-element.tsx";
import WaterfallListElement from "../../../ui-components/waterfall-list-element/waterfall-list-element.tsx";

import RaindropMotionFadeUpGroup from "../../../ui-components/raindrop-motion-fade-up-group/raindrop-motion-fade-up-group.tsx";

enum Stage {
  Welcome = "welcome",
  RaindropTextIntro = "intro-raindrop-text",
  RaindropTextIntro2 = "intro-raindrop-text-2",
  RaindropTextIntro3 = "intro-raindrop-text-3",
  CharityIntro = "intro-charity",
  RaindropCircleIntro = "intro-raindrop-circle",
  RaindropCirclePart2 = "intro-raindrop-circle-part-2",

  OrganisationActivityText = "organisation-activity-text",

  OrganisationActivity = "organisation-activity",
  WaterfallActivityIntro = "waterfall-activity-intro",
  WaterfallActivity = "waterfall-activity",
  WaterfallInCircle = "waterfall-in-circle",
  ContributionDay = "contribution-day",
  // WaterfallCascading = "waterfall-cascading",
  Close = "close",
}

const WaterfallComponent = ({
  urlUser = "https://production-raindrop-s3-public.s3.eu-west-2.amazonaws.com/profile_picture_1.jpeg",
}) => {
  return (
    <RaindropCard additionalClasses="flex w-full">
      <div className="flex flex-row gap-4 w-full items-center">
        <WaterfallIcon
          urlUser={urlUser}
          urlOrganisation={EXAMPLE_ORGANISATION_ALPHA_URL}
        />
        <div className="flex flex-col text-left w-full">
          <RaindropTextHeading1>
            Backflips for mental health
          </RaindropTextHeading1>

          <p className="text-color-dark-text-secondary">@hannah12</p>
        </div>
      </div>
    </RaindropCard>
  );
};

const StageWelcome = () => {
  return (
    <RaindropMotionFadeUp>
      <div className="flex flex-col gap-8 text-left ">
        <div className="flex flex-col items-center">
          <h1 className="text-xl uppercase font-black dark:text-color-dark-text-primary text-color-text-primary">
            Welcome to
          </h1>

          <RaindropTitle size={Size.Huge} isPrimary={true} />

          <p className="font-black text-lg pt-2 text-color-dark-text-secondary">
            A simple app for good things
          </p>
        </div>
      </div>
      <RaindropSparkleCurtain />
    </RaindropMotionFadeUp>
  );
};

const StageIntroRaindropCircle = () => {
  return (
    <FlexCol tailwindGap="gap-12">
      <RaindropMotionFadeUpGroup>
        <RaindropCard>
          <FlexCol tailwindGap="gap-6">
            <RaindropCircle
              id="raindrop-circle-1"
              key={"raindrop-circle"}
              size="XSMALL"
              sausageValues={[
                { value: 100, selected: false, color: Color.Blue },
              ]}
            />

            <OrganisationListElement
              color={Color.Blue}
              doShowColorIndicator={true}
              doShowGiveButton={false}
              isClickable={false}
            />
          </FlexCol>
        </RaindropCard>
        <FlexCol tailwindGap="gap-1">
          <RaindropTextHeading1 className="w-full">
            This is your Raindrop Circle
          </RaindropTextHeading1>
          <RaindropTextSubtitle>
            It represents your total contribution that you are giving each
            month. Right now, it's all going to Mind, a charity that supports
            mental health.
            {/* Your Raindrop Circle is like a pie chart. It shows you how you've
            split your contribution between the organisations you support. */}
          </RaindropTextSubtitle>
        </FlexCol>
      </RaindropMotionFadeUpGroup>
    </FlexCol>
  );
};

const StageIntroRaindropCirclePart2 = () => {
  const sausageValues = [
    { value: 80, selected: false, color: Color.Blue },
    { value: 20, selected: false, color: Color.Green },
  ];

  return (
    <FlexCol tailwindGap="gap-12">
      <RaindropMotionFadeUpGroup>
        <RaindropCard>
          <FlexCol tailwindGap="gap-6">
            <RaindropCircle
              id="raindrop-circle-2"
              key={"raindrop-circle"}
              size="XSMALL"
              sausageValues={sausageValues}
            />

            <OrganisationListElement
              color={Color.Blue}
              doShowColorIndicator={true}
              doShowGiveButton={false}
              isClickable={false}
            />
            <OrganisationListElement
              color={Color.Green}
              doShowColorIndicator={true}
              doShowGiveButton={false}
              presignedUrl={EXAMPLE_ORGANISATION_BETA_URL}
              name={EXAMPLE_ORGANISATION_BETA_NAME}
              isClickable={false}
            />
          </FlexCol>
        </RaindropCard>
        <FlexCol tailwindGap="gap-1">
          <RaindropTextHeading1 className="w-full">
            Splitting your contribution
          </RaindropTextHeading1>
          <RaindropTextSubtitle>
            Your Raindrop Circle is like a pie chart. It shows you how you've
            split your contribution between organisations.
          </RaindropTextSubtitle>
          <RaindropTextSubtitle>
            You decide who needs your support and when. You can adjust your
            distribution or pause entirely at any time.
          </RaindropTextSubtitle>
        </FlexCol>
      </RaindropMotionFadeUpGroup>
    </FlexCol>
  );
};

const StageIntroRaindropCirclePart3 = () => {
  const sausageValues = [
    { value: 40, selected: false, color: Color.Blue },
    { value: 20, selected: false, color: Color.Green },
    { value: 40, selected: false, color: Color.Purple },
  ];

  return (
    <FlexCol tailwindGap="gap-12">
      <RaindropMotionFadeUpGroup>
        <RaindropCard>
          <FlexCol tailwindGap="gap-6">
            <RaindropCircle
              id="raindrop-circle"
              key={"raindrop-circle"}
              size="XSMALL"
              sausageValues={sausageValues}
            />
            <FlexCol>
              <OrganisationListElement
                doShowColorIndicator={true}
                doShowGiveButton={false}
                color={SausageStyleColor.Blue}
                isClickable={false}
              />
              <OrganisationListElement
                doShowColorIndicator={true}
                doShowGiveButton={false}
                color={SausageStyleColor.Green}
                presignedUrl={EXAMPLE_ORGANISATION_BETA_URL}
                name={EXAMPLE_ORGANISATION_BETA_NAME}
                isClickable={false}
              />
              <WaterfallListElement
                color={SausageStyleColor.Purple}
                title="Running for Mind"
              />
            </FlexCol>
          </FlexCol>
        </RaindropCard>
        <FlexCol tailwindGap="gap-1">
          <RaindropTextHeading1 className="w-full">
            Supporting a Waterfall
          </RaindropTextHeading1>
          <RaindropTextSubtitle>
            You can support Tom by contributing to his Waterfall, just like
            supporting an organisation. Your money passes through Tom straight
            to the charity he is trying to support
          </RaindropTextSubtitle>
        </FlexCol>
      </RaindropMotionFadeUpGroup>
    </FlexCol>
  );
};

const StageOrganisationActivity = () => {
  return (
    <FlexCol tailwindGap="gap-6">
      <RaindropMotionFadeUpGroup>
        <OrganisationActivityElement
          organisationName={EXAMPLE_ORGANISATION_ALPHA_NAME}
          organisationPresignedUrl={EXAMPLE_ORGANISATION_ALPHA_URL}
          text={
            "In the last week our team responded to 327 calls on our emergency hotline "
          }
          createdAt={Date()}
        />

        <FlexCol tailwindGap="gap-1">
          <RaindropTextHeading1 className="w-full">
            Bite-sized updates
          </RaindropTextHeading1>
          <RaindropTextSubtitle>
            The organisations you support post updates to let you know what
            they've been doing.
          </RaindropTextSubtitle>
          <RaindropTextSubtitle>
            These are bite-sized pieces of positive info to help you see the
            impact you are making.
          </RaindropTextSubtitle>

          <RaindropTextSubtitle>
            <FlexRow
              className="mt-4 border p-4 rounded-lg border-color-dark-border-primary"
              tailwindGap="gap-4 "
            >
              <i className="fa fa-info-circle" />
              <i>
                Organisations are banned from publishing guilt messaging on the
                platform
              </i>
            </FlexRow>
          </RaindropTextSubtitle>
        </FlexCol>
      </RaindropMotionFadeUpGroup>
    </FlexCol>
  );
};

const StageWaterfallActivity = () => {
  return (
    <FlexCol tailwindGap="gap-12">
      <RaindropMotionFadeUpGroup>
        <RaindropCard>
          <WaterfallListElement
            doShowColorIndicator={false}
            title="Running for Mind"
            urlUser={EXAMPLE_ACCOUNT_USER_URL}
          />
        </RaindropCard>

        <FlexCol tailwindGap="gap-1">
          <RaindropTextHeading1 className="w-full">
            This is a Raindrop Waterfall
          </RaindropTextHeading1>
          <RaindropTextSubtitle>
            Our friend Tom wants to raise money for Mind by running a marathon.
          </RaindropTextSubtitle>
          <RaindropTextSubtitle>
            He has created a Raindrop Waterfall and posts pictures of himself
            running everyday. You can follow him, like his content and even
            share his Waterfall.
          </RaindropTextSubtitle>
        </FlexCol>
      </RaindropMotionFadeUpGroup>
    </FlexCol>
  );
};

const StageWaterfallCascading = () => {
  return (
    <RaindropMotionFadeUp className="h-full">
      <div className="flex flex-col w-full gap-4 h-full  ">
        <div className="flex flex-col gap-2 h-full justify-center">
          <RaindropMotionFadeUp>
            <WaterfallComponent
              urlUser={
                "https://production-raindrop-s3-public.s3.eu-west-2.amazonaws.com/profile_picture_1.jpeg"
              }
            />
          </RaindropMotionFadeUp>

          <RaindropMotionFadeUp delay={0.8}>
            <WaterfallComponent
              urlUser={
                "https://production-raindrop-s3-public.s3.eu-west-2.amazonaws.com/profile_picture_2.jpeg"
              }
            />
          </RaindropMotionFadeUp>

          <RaindropMotionFadeUp delay={1.8}>
            <WaterfallComponent
              urlUser={
                "https://production-raindrop-s3-public.s3.eu-west-2.amazonaws.com/profile_picture_3.jpeg"
              }
            />
          </RaindropMotionFadeUp>
        </div>

        <RaindropCard>
          <RaindropTextHeading1>Cascading a waterfall</RaindropTextHeading1>

          <RaindropTextParagraph>
            Like an idea and want to take part? You can duplicate any waterfall
            you like and claim it as your own. We call this cascading a
            waterfall.
          </RaindropTextParagraph>
        </RaindropCard>
      </div>
    </RaindropMotionFadeUp>
  );
};

const StageClose = () => {
  return (
    <FlexCol>
      <RaindropMotionFadeUp>
        <i className="fas fa-heart text-color-raindrop-primary text-8xl" />
      </RaindropMotionFadeUp>

      <RaindropMotionFadeUp delay={0.4}>
        <RaindropTextCallout text={"Enjoy!"} isPrimary={false} />
      </RaindropMotionFadeUp>
    </FlexCol>
  );
};

const MainStage = ({ stage }) => {
  const navigate = useNavigate();
  return (
    <FlexCol className=" ">
      <FlexCol className="h-full justify-center">
        {stage === Stage.Welcome && <StageWelcome />}
        {stage === Stage.RaindropTextIntro && (
          <FlexCol>
            <RaindropMotionFadeUpGroup>
              <RaindropTextCallout
                text={"Raindrop is a unique take on "}
                isPrimary={false}
              />

              <RaindropTextCallout
                text={"charitable giving"}
                className="w-full"
              />
            </RaindropMotionFadeUpGroup>
          </FlexCol>
        )}
        {stage === Stage.RaindropTextIntro2 && (
          <FlexCol tailwindGap="gap-6">
            <RaindropMotionFadeUpGroup>
              <i className="fa fa-quote-left w-full text-color-raindrop-primary text-6xl" />

              <RaindropTextCallout
                text={"I can afford to give $10 each month to do good..."}
                isPrimary={false}
                className="w-full"
              />
            </RaindropMotionFadeUpGroup>
          </FlexCol>
        )}
        {stage === Stage.RaindropTextIntro3 && (
          <FlexCol tailwindGap="gap-6">
            <RaindropMotionFadeUpGroup delay={0.4}>
              <i className="fa fa-quote-left w-full text-color-raindrop-primary text-6xl" />
              <RaindropTextCallout
                text={
                  "...but at any time I want to change where my money is going "
                }
                isPrimary={false}
              />

              <RaindropTextCallout
                text={"without lock-in."}
                className="w-full"
              />
              <RaindropTextCallout text={"without guilt."} className="w-full" />
            </RaindropMotionFadeUpGroup>
          </FlexCol>
        )}
        {stage === Stage.CharityIntro && (
          <FlexCol tailwindGap="gap-12" className="h-full justify-center">
            <RaindropMotionFadeUpGroup>
              <RaindropCard>
                <OrganisationListElement
                  doShowGiveButton={false}
                  isClickable={false}
                />
              </RaindropCard>

              <FlexCol tailwindGap="gap-2">
                <RaindropTextHeading1 className="w-full">
                  This is a charity
                </RaindropTextHeading1>

                <RaindropTextSubtitle>
                  Charities work tirelessly to improve our world, by providing
                  water, shelter, food, education, homes, medicine, disaster
                  relief, and so much more.
                </RaindropTextSubtitle>
                <RaindropTextSubtitle className="w-full">
                  Let's go and support them.
                </RaindropTextSubtitle>
              </FlexCol>
            </RaindropMotionFadeUpGroup>
          </FlexCol>
        )}
        {stage === Stage.RaindropCircleIntro && <StageIntroRaindropCircle />}
        {stage === Stage.RaindropCirclePart2 && (
          <StageIntroRaindropCirclePart2 />
        )}

        {stage === Stage.OrganisationActivityText && (
          <FlexCol tailwindGap="gap-2">
            <RaindropMotionFadeUpGroup>
              <i className="fa fa-quote-left w-full text-color-raindrop-primary text-6xl" />
              <RaindropTextCallout
                text={".. but is my money doing any good? "}
                isPrimary={false}
              />
            </RaindropMotionFadeUpGroup>
          </FlexCol>
        )}

        {stage === Stage.WaterfallActivityIntro && (
          <FlexCol tailwindGap="gap-2">
            <RaindropMotionFadeUpGroup>
              <i className="fa fa-quote-left w-full text-color-raindrop-primary text-6xl" />
              <RaindropTextCallout
                text={"What if I want to encourage others to donate?"}
                isPrimary={false}
              />
            </RaindropMotionFadeUpGroup>
          </FlexCol>
        )}
        {stage === Stage.OrganisationActivity && <StageOrganisationActivity />}
        {stage === Stage.WaterfallActivity && <StageWaterfallActivity />}
        {stage === Stage.WaterfallInCircle && <StageIntroRaindropCirclePart3 />}

        {stage == Stage.ContributionDay && (
          <FlexCol tailwindGap="gap-10">
            <RaindropMotionFadeUpGroup>
              <div className="w-fit">
                <FlexCol className=" font-black text-5xl border-4 p-8 rounded-lg border-color-border-primary dark:border-color-dark-border-primary ">
                  <i className="fa fa-calendar text-3xl" />
                  <div>17th</div>
                </FlexCol>
              </div>
              <FlexCol tailwindGap="gap-1">
                <RaindropTextHeading1 className="w-full">
                  Your contribution day
                </RaindropTextHeading1>
                <RaindropTextSubtitle>
                  Your contribution day is the 17th of each month. This is the
                  day we will collect your contribution and distribute it to the
                  organisations you are supporting at that moment.
                </RaindropTextSubtitle>
              </FlexCol>
            </RaindropMotionFadeUpGroup>
          </FlexCol>
        )}
        {stage === Stage.Close && <StageClose />}
      </FlexCol>
    </FlexCol>
  );
};

const MainNavigation = ({
  stage,
  onNext = () => {},
  onSkip = () => {},
  onBack = () => {},
}) => {
  let showBack = true;
  let nextButtonTitle = "Next";

  if (stage === Stage.Welcome) {
    showBack = false;
    nextButtonTitle = "Begin tour";
  }

  if (stage === Stage.Close) {
    nextButtonTitle = "End Tour";
  }

  return (
    <div className=" flex flex-col items-center  p-6 w-full max-w-md gap-6 ">
      <div className="flex flex-row gap-2 w-full">
        {showBack && (
          <RaindropButton
            title={"Back"}
            onClick={onBack}
            size={Size.Large}
            isFluid={true}
          />
        )}
        <RaindropButton
          title={nextButtonTitle}
          onClick={onNext}
          size={Size.Large}
          style={ButtonStyle.Primary}
          isFluid={true}
        />
      </div>
    </div>
  );
};

const MainLegalDisclaimer = () => {
  return (
    <RaindropTextFootnote>
      Copyright © 2025 The Raindrop Group Limited. All rights reserved.
    </RaindropTextFootnote>
  );
};

const RaindropTour = ({ userCurrent, setUserCurrent }) => {
  const navigate = useNavigate();

  const [stage, setStage] = useState(Stage.Welcome);

  const onCompleteOnboarding = () => {
    if (!userCurrent) {
      navigate("/raindrop");
      return;
    }

    if (userCurrent.status === "USER_STATUS_ACTIVE") {
      navigate("/raindrop");
      return;
    }

    return fetchGraphQL(`
      mutation {
        accountUserMarkActive
      }
    `).then((response) => {
      console.log("response", response);
      setUserCurrent((prev) => ({
        ...prev,
        status: "USER_STATUS_ACTIVE",
      }));
    });
  };

  const onNext = () => {
    if (stage === Stage.Close) {
      onCompleteOnboarding();
      return;
    }
    const stages = Object.values(Stage);
    const currentIndex = stages.indexOf(stage);
    const newIndex = currentIndex + 1;
    setStage(stages[newIndex]);
  };

  const onBack = () => {
    if (stage === Stage.Welcome) {
      return;
    }
    const stages = Object.values(Stage);
    const currentIndex = stages.indexOf(stage);
    const newIndex = currentIndex - 1;
    setStage(stages[newIndex]);
  };

  return (
    <RaindropPage>
      <FlexRow className="flex-row-reverse max-w-md">
        <RaindropButton
          style={ButtonStyle.Tertiary}
          title="Skip"
          onClick={() => {
            navigate("/raindrop");
          }}
        />
      </FlexRow>
      <FlexCol className="w-full max-w-md justify-center h-full">
        <MainStage stage={stage} />
      </FlexCol>
      <MainNavigation
        stage={stage}
        onNext={onNext}
        onBack={onBack}
        onSkip={onCompleteOnboarding}
      />

      {stage == Stage.Welcome && <MainLegalDisclaimer />}
    </RaindropPage>
  );
};

export default RaindropTour;
